var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Popup',{attrs:{"title":"Transbank","errorMsg":_vm.error},on:{"close":_vm.closed}},[_c('div',{attrs:{"id":"transbank-loader"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }